var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      staticClass: "p-4",
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _vm.archived
                ? _c("CardInfoChip", {
                    staticClass: "ml-2",
                    attrs: { message: "Archived", gray: "" },
                  })
                : _vm._e(),
              !_vm.archived
                ? _c(
                    "div",
                    { staticClass: "flex ml-auto items-center" },
                    [
                      _c("UiButton", {
                        attrs: {
                          variant: "linkButton",
                          size: "no",
                          buttonText: "Edit",
                        },
                        on: { click: _vm.handleEditClick },
                      }),
                      _vm.dialog
                        ? _c("GroupModal", {
                            attrs: {
                              currentUser: _vm.currentUser,
                              dialog: _vm.dialog,
                              data: _vm.group,
                              companyId: _vm.companyId,
                            },
                            on: {
                              refetch: function ($event) {
                                return _vm.$emit("refetch")
                              },
                              close: function ($event) {
                                _vm.dialog = false
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c("GroupConversationProvider", {
                staticClass: "flex items-center mt-0.5 ml-2",
                attrs: {
                  contractors: _vm.contractors,
                  managers: _vm.managers,
                  currentUserRole: _vm.currentUser.role,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({
                      participantsExist,
                      groupConversationUsers,
                    }) {
                      return [
                        participantsExist
                          ? _c(
                              "ColorIconContainer",
                              {
                                attrs: { iconStyle: "" },
                                on: { click: _vm.groupMessage },
                              },
                              [_c("ChatIcon")],
                              1
                            )
                          : _vm._e(),
                        _c("CreateGroupConversationModal", {
                          attrs: {
                            companyId: _vm.companyId,
                            currentUserId: _vm.currentUser.id,
                            groupConversationUsers: groupConversationUsers,
                            projectTitle: _vm.groupName,
                          },
                          model: {
                            value: _vm.newConversationDialog,
                            callback: function ($$v) {
                              _vm.newConversationDialog = $$v
                            },
                            expression: "newConversationDialog",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "w-full" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "RouterLink",
              {
                staticClass: "flex items-center",
                attrs: {
                  to: {
                    name: _vm.groupDetailsRouteName,
                    params: { id: _vm.groupId },
                  },
                },
              },
              [
                _c("CircleWithInitials", {
                  staticClass: "mr-2",
                  attrs: { title: _vm.group.name },
                }),
                _c("div", [
                  _c(
                    "p",
                    {
                      staticClass:
                        "font-bold text-base mb-2 hover:text-primary-500",
                    },
                    [_vm._v(" " + _vm._s(_vm.groupName) + " ")]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "xl:flex w-full -mt-1" }, [
          _c(
            "div",
            { staticClass: "ml-10 xl:w-5/12" },
            [
              _c("CardBodyItem", {
                staticClass: "text-base pr-2",
                attrs: {
                  label: "Location",
                  content: _vm.groupLocation,
                  wide: "",
                },
              }),
              _c(
                "CardBodyItem",
                { attrs: { label: "Postings", wide: "" } },
                [
                  _c("ItemChipsWithMore", {
                    attrs: {
                      items: _vm.groupPostings,
                      navigateTo: _vm.navigateToDetails,
                      routeName: _vm.routes.RECRUITING_POSTING,
                    },
                  }),
                ],
                1
              ),
              _c(
                "CardBodyItem",
                { attrs: { label: "Clients", wide: "" } },
                [
                  _c("ItemChipsWithMore", {
                    attrs: {
                      items: _vm.groupProjects,
                      navigateTo: _vm.navigateToDetails,
                      routeName: _vm.routes.PROJECT_ACTIVITY,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-col ml-10 xl:w-7/12" },
            [
              _c(
                "CardBodyItem",
                { attrs: { label: "Skills", wide: "" } },
                [
                  _c("ItemChipsWithMore", {
                    attrs: {
                      items: _vm.groupSkills,
                      navigateTo: _vm.navigateToDetails,
                    },
                  }),
                ],
                1
              ),
              _c(
                "CardBodyItem",
                { attrs: { label: "Contractors", wide: "" } },
                [
                  _c("ItemChipsWithMore", {
                    attrs: {
                      items: _vm.groupContractors,
                      navigateTo: _vm.navigateToDetails,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ itemsToRender }) {
                          return _vm._l(itemsToRender, function (item) {
                            return _c(
                              "EmployeeRemovedFromCompanyTooltip",
                              {
                                key: item.id,
                                attrs: { disabled: !item.deleted },
                              },
                              [
                                _c("ItemChip", {
                                  attrs: {
                                    itemId: item.id,
                                    itemName: item.name,
                                    itemRole: item.role,
                                    itemExtra: item.extra,
                                    avatar: item.avatar,
                                    routeParams: item.routeParams,
                                    removed: item.deleted,
                                    routeName:
                                      _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                                    isPerson: "",
                                  },
                                }),
                              ],
                              1
                            )
                          })
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.isAdmin
                ? _c(
                    "CardBodyItem",
                    { attrs: { label: "Managers", wide: "" } },
                    [
                      _c("ItemChipsWithMore", {
                        attrs: {
                          items: _vm.groupManagers,
                          navigateTo: _vm.navigateToDetails,
                          routeName: _vm.routes.MANAGER_ABOUT,
                          isPerson: "",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }